import { OPEN_MODAL, WATERFALL_GRAPH_LIST, WATERFALL_GRAPH_LIST_ERROR, WATERFALL_GRAPH_LIST_SUCCESS, WATERFALL_GRAPH_UPDATE_DATA } from './constants';

export default function waterfallManagementReducer(state, action) {
	// let waterfallData = [];
	switch (action.type) {
	case OPEN_MODAL :
		return { ...state, openModal : action.payload };
	case WATERFALL_GRAPH_LIST :
		return { ...state, loading : true, error : false};
	case WATERFALL_GRAPH_LIST_SUCCESS :
		return { ...state, loading : false, error : false, waterfallData : action.payload};
	case WATERFALL_GRAPH_LIST_ERROR : 
		return { ...state, loading : false, error : true};
	case WATERFALL_GRAPH_UPDATE_DATA:
		return { ...state, updateData : action.payload };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}